import React from 'react';
import { connect } from 'react-redux';
import HoverActionHeader from '@/components/HoverActionHeader';
import { editRole } from '../actions';

const RoleFieldHeader = ({
  code,
  category,
  value,
  icon,
  canEdit,
  showEdit,
  isSystem,
}) => (
  <HoverActionHeader
    icon={icon}
    canEdit={canEdit}
    showEdit={() => showEdit(category, code)}
    isSystem={isSystem}
    value={value}
    className="aridhia-role-list-header"
  />
);

const mapDispatchToProps = {
  showEdit: editRole,
};

export default connect(null, mapDispatchToProps)(RoleFieldHeader);
